import { OrderStatus } from '../../domain/types/order.types';

const CHRONOS_STATUSES = ['P', 'M', 'F', 'G', 'L', 'E', 'A', 'Z'];

export function isCronosStatusUseCase(status: OrderStatus) {
    return CHRONOS_STATUSES.includes(status);
}

export const __test__ = {
    CHRONOS_STATUSES,
};
